import React from "react";

function EllipseIcon({ hovered }) {
  return (
    <svg
      className="relative -top-2"
      width="165"
      height="34"
      viewBox="0 0 165 34"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="ellipse"
        fill={!hovered ? "#828282" : "#06a7e2"}
        d="M 81.922 0.0236139C 41.3666 -0.819778 7.29998 21.1078 0 32.915C 9.46294 25.3247 39.0955 10.1443 81.922 10.1443C 124.749 10.1443 154.922 25.3247 164.655 32.915C 141.944 12.6744 126.533 0.951345 81.922 0.0236139Z"
      ></path>
    </svg>
  );
}

export default EllipseIcon;
